const Config = {
    CLIENT_APP_URL: process.env.REACT_APP_CLIENT_APP_URL || '',
    API_URL: process.env.REACT_APP_API_URL || '',
    MFA_API_URL: process.env.REACT_APP_MFA_API_URL || '',
    AUTH_URL : process.env.REACT_APP_AUTH_URL || ''
}

export default Config